// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"499":"57a9575e","539":"57a9575e","550":"57a9575e","826":"24b329c0","881":"fb778e02"}[chunkId] + ".chunk.css";
};